module.exports = __webpack_public_path__ + "c8598ffe447f51ac8a5b9917667db9bd.svg";